import { render, staticRenderFns } from "./index.vue?vue&type=template&id=083b7110&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./my-assignments.scoped.css?vue&type=style&index=0&id=083b7110&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b7110",
  null
  
)

export default component.exports